import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';
import { afterNextRender, Component, ElementRef, Inject, inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddNoteModalData } from './add-note-modal.model';

@Component({
  selector: 'app-add-note-modal',
  templateUrl: './add-note-modal.component.html',
  styleUrls: ['./add-note-modal.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'add-note-modal',
    },
  ],
  standalone: false,
})
export class AddNoteModalComponent {
  @ViewChild('noteTextarea') noteTextarea!: ElementRef<HTMLTextAreaElement>;
  
  public readonly MAX_CHARACTERS = 500;
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  noteControl = new FormControl(this.data.existingNote || '', [
    Validators.maxLength(this.MAX_CHARACTERS)
  ]);

  constructor(
    private dialogRef: MatDialogRef<AddNoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddNoteModalData
  ) {
    // Focus the textarea after the next render completes
    afterNextRender(() => {
      this.noteTextarea.nativeElement.focus();
    });
  }

  onSave(): void {
    if (this.noteControl.valid) {
      this.dialogRef.close({
        note: this.noteControl.value?.trim() || '',
        saved: true
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close({
      saved: false
    });
  }

  get characterCount(): number {
    return this.noteControl.value?.length || 0;
  }
}